module.exports = __webpack_public_path__ + "img/island-hopping-full-colour.76a15b0c.svg";